import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { getClient } from '@chegg/rio-sdk-web';
import { trigger as clientCallback } from "../clientCallback";
import { EventTypes, recordEvents } from "../../utils/newRelicEvents";
var rioClient;
export function getRioClient() {
  rioClient = getClient();
  return rioClient;
}
export async function sendRioEvent(type, data) {
  try {
    await getRioClient().sendEvent({
      type: type,
      data: data,
      eventVersion: 3
    });
    clientCallback({
      type: 'log',
      payload: {
        type: type,
        data: data
      }
    });
  } catch (error) {
    recordEvents(_defineProperty({}, EventTypes.sendRioEventFail, {
      type: type,
      data: data
    }));
  }
}
export function getUUID() {
  var uuid = null;
  try {
    uuid = JSON.parse(atob(document.cookie.split('; ').filter(function (c) {
      return c.substr(0, 8) === 'id_token';
    })[0].split('.')[1])).sub;
    return uuid;
  } catch (error) {
    //
  }
}
export function updateRioState(state) {
  getRioClient().updateState(state);
}
export function getProfileSourceData(previousView) {
  var sourcePage = '';
  var sourceProduct = '';
  if (!previousView) {
    return {
      sourcePage: sourcePage,
      sourceProduct: sourceProduct
    };
  }
  if (previousView !== null && previousView !== void 0 && previousView.property) {
    sourcePage += "".concat(previousView.property, "|");
  }
  if (previousView !== null && previousView !== void 0 && previousView.experience) {
    sourceProduct += "".concat(previousView.experience, "|");
  }
  if (previousView !== null && previousView !== void 0 && previousView.feature) {
    sourcePage += "".concat(previousView.feature, "|");
    sourceProduct += "".concat(previousView.feature, "|");
  }
  if (previousView !== null && previousView !== void 0 && previousView.view_name) {
    sourcePage += "".concat(previousView.view_name);
  } else if (document.referrer) {
    sourcePage += "".concat(document.referrer);
  } else {
    sourcePage += "".concat(location.href);
  }
  return {
    sourcePage: sourcePage,
    sourceProduct: sourceProduct
  };
}